import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { initializeAnalytics, firebaseApp } from "./firebase-analytics.js";

const container = document.getElementById("root");
const root = createRoot(container);

initializeAnalytics(firebaseApp);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
